// infra/api/Torres.js
import axiosInstance from '../axios';

/**
 * Buscar lista paginada de torres
 * @param {number} page - número da página (base 0)
 * @param {number} size - quantidade de itens por página
 */
export const getTowers = async (page = 0, size = 10, filters = {}) => {
    try {
        const params = new URLSearchParams({
            page,
            size,
        });

        Object.entries(filters || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                if (Array.isArray(value)) {
                    value.forEach((v) => params.append(key, v));
                } else {
                    params.append(key, value);
                }
            }
        });

        const response = await axiosInstance.get(
            `/torres?${params.toString()}`
        );
        return response.data;
    } catch (error) {
        console.error('Falha ao buscar torres:', error);
        throw error;
    }
};

/**
 * Buscar torres por número de série (contém, case-insensitive)
 * @param {string} serialNumber - número de série a ser buscado
 */
export const searchTowers = async (serialNumber) => {
    try {
        const response = await axiosInstance.get(
            `/torres/search?numeroSerie=${serialNumber}`
        );
        return response.data; // array de torres
    } catch (error) {
        console.error('Falha ao buscar torre por número de série:', error);
        throw error;
    }
};

/**
 * Vincular / desvincular protocolo de uma torre
 * PUT /torres/protocol
 */
export const vincularProtocolo = async (payload) => {
    try {
        const response = await axiosInstance.put(`/torres/protocol`, payload);
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.message || 'Falha ao vincular protocolo'
        );
    }
};

/**
 * Definir tipo da torre (LIVRE | PRINCIPAL | DUPLICADA)
 * PUT /torres/{id}/definir-tipo
 */
export const definirTipoTorre = async (idTorre, payload) => {
    try {
        const response = await axiosInstance.put(
            `/torres/${idTorre}/definir-tipo`,
            payload
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.message || 'Falha ao alterar tipo da torre'
        );
    }
};

export const atualizarVinculoTorre = async (payload) => {
    try {
        const response = await axiosInstance.put('/torres/vinculo', payload);
        return response.data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message ||
                'Falha ao atualizar vínculos da torre.'
        );
    }
};

/**
 * Atualizar Tag da Torre
 * POST /torres/tag
 * Payload: { idTorre: string, tag: string }
 */
export const atualizarTagTorre = async (payload) => {
    try {
        const response = await axiosInstance.put('/torres/tag', payload);
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.message || 'Falha ao atualizar a tag da torre'
        );
    }
};

/**
 * Configurar ganho/tempo de integração do sensor espectral manualmente.
 * Só tem efeito quando a torre não tem protocolo atribuído (modo telemetria).
 * PUT /torres/serial/{numeroSerie}/sensor-config
 * Payload: { measurement: 'turbidimetry'|'nephelometry'|'fluorescence', gain: number, integrationTimeMs: number }
 */
export const configurarSensorTorre = async (numeroSerie, payload) => {
    try {
        const response = await axiosInstance.put(
            `/torres/serial/${numeroSerie}/sensor-config`,
            payload
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.message ||
                'Falha ao configurar o sensor da torre'
        );
    }
};

/**
 * Define (ou remove) a diluicao padrao do dispositivo — expoente 0..6, aplicado como 10^-n.
 * Pre-preenche a diluicao nas telas de nova analise e semeia o experimento no nascimento.
 *   diluicao === null  -> remove o preset
 *   diluicao === 0     -> preset legitimo ("pura"), NAO e ausencia
 * Exige ADMIN/GESTOR (o backend responde 403 caso contrario).
 */
export const definirDiluicaoPadraoTorre = async (numeroSerie, diluicao) => {
    try {
        const response = await axiosInstance.put(
            `/torres/serial/${numeroSerie}/diluicao-padrao`,
            { diluicao }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.message ||
                'Falha ao definir a diluição padrão do dispositivo'
        );
    }
};

export default {
    getTowers,
    searchTowers,
    vincularProtocolo,
    definirTipoTorre,
    atualizarVinculoTorre,
    atualizarTagTorre,
    configurarSensorTorre,
    definirDiluicaoPadraoTorre,
};
